import React, { useEffect, useRef } from 'react';

const baseStyle = {
  position: 'absolute',
  top: 0,
  width: '6px',
  height: '100%',
  cursor: 'col-resize',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  WebkitTouchCallout: 'none',
  WebkitTapHighlightColor: 'transparent',
  touchAction: 'none',
  zIndex: 1
};

// React attaches touchstart as a passive listener by default, so an
// onTouchStart prop here couldn't preventDefault() iOS's long-press
// text-selection/callout gesture. A native, non-passive listener can.
//
// The hit area is kept inside its own cell (never a negative left/right
// offset) because reason/condition cells get overflow: hidden from the
// .ellipsis class - anything that visually spills past the cell's own
// border gets clipped there and stops being touchable, even though it's
// still drawn fine on cells without that class (e.g. <th>).
const ColumnResizeHandle = ({ onMouseDown, side = 'right' }) => {
  const handleRef = useRef(null);

  useEffect(() => {
    const el = handleRef.current;
    if (!el || !onMouseDown) return undefined;

    const handleTouchStart = event => {
      event.preventDefault();
      onMouseDown(event);
    };

    el.addEventListener('touchstart', handleTouchStart, { passive: false });
    return () => el.removeEventListener('touchstart', handleTouchStart);
  }, [onMouseDown]);

  // No handler means manual resizing is off (see useColumnWidths' `enabled`
  // option) - render nothing rather than a dead, inert drag strip.
  if (!onMouseDown) return null;

  const style = {
    ...baseStyle,
    [side]: 0
  };

  return (
    <span
      ref={handleRef}
      className='column-resize-handle'
      style={style}
      onMouseDown={onMouseDown}
      onClick={event => event.stopPropagation()}
    />
  );
};

export default ColumnResizeHandle;
